<template>

    <div class="ec-page-content ec-vendor-uploads section-space-p">

        <div class="container">

            <div class="ec-shop-rightside ">
                <div class="ec-vendor-dashboard-card ec-vendor-setting-card">
                    <div class="ec-vendor-card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="ec-vendor-block-profile">
                                    <div class="ec-vendor-block-img space-bottom-30">


                                        <div class=" d-flex">
                                            <h5 class="name w-100 text-center"> {{ $t('My Address Book')}} </h5>


                                            <button class="btn btn-lg btn-primary"
                                                    data-bs-toggle="modal" data-bs-target="#add-address">
                                                <i data-feather="plus" class="me-2"></i>
                                                {{ $t('Add New Address') }}
                                            </button>

                                        </div>

                                    </div>

<!--                                    <h5>عناوين الشحن الخاصة بي</h5>-->

                                    <div class="row">
                                        <div class="col-md-6 col-sm-12"
                                             v-for="address in items?.data" :key="address.id" >
                                            <div class="ec-vendor-detail-block ec-vendor-block-email space-bottom-30">

                                                <h6 class="d-flex">

                                                    <span class="w-100 py-2 ">{{ address?.name }}</span>


                                                    <a class="btn btn-sm add-button " data-bs-toggle="modal"
                                                            data-bs-target="#edit-address" @click="address_edited = address">

                                                        <i class="fi-rr-edit"></i>
                                                    </a>

                                                    <a class="btn btn-sm add-button " data-bs-toggle="modal"
                                                            data-bs-target="#removeProfile" @click="address_deleted = address">
                                                        <i class="fi-rr-trash"></i>
                                                    </a>
                                                </h6>

                                                <ul class="px-2">
                                                    <li><strong>{{ $t('Address') }} : </strong> {{ address?.address }} </li>
                                                    <li><strong>{{ $t('Country') }} : </strong> {{ address?.country?.name }} </li>
                                                    <li><strong> {{ $t('City') }} : </strong> {{ address?.city?.name }} </li>
                                                    <li><strong> {{ $t('Phone') }} : </strong> {{ address?.phone }} </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <confirmation-modal
        :message="$t('هل تريد بالفعل حذف العنوان؟')"
        @confirm="onDelete" :id="'removeProfile'"/>

    <create-address @add="addItem"></create-address>


    <edit-address @update="updateItem" :address="address_edited"></edit-address>

</template>

<script>

import {useToast} from "vue-toastification";

const toast = useToast();
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import EditAddress from "./edit.vue";
import CreateAddress from "./create.vue";
import ConfirmationModal from "../../components/handling/ConfirmationModal.vue";

export default {
    components: {
        Bootstrap5Pagination,
        CreateAddress,
        EditAddress,
        ConfirmationModal
    },
    data() {
        return {
            address_edited: {},
            address_deleted: {},
            items: {},
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        addItem(newItemData) {
            console.log('addItem');
            console.log(newItemData);
            this.items?.data?.unshift(newItemData);
        },
        updateItem(newItemData) {
            console.log('updateItem');
            console.log(newItemData);
            const itemIndex = this.items?.data?.findIndex(item => item.id === newItemData.id);
            console.log(itemIndex);
            if (itemIndex !== -1) {
                this.items.data[itemIndex] = {...this.items?.data[itemIndex], ...newItemData};
            }
        },
        async onDelete() {
            await this._delete(this.address_deleted);
            this.address_deleted = {};
        },
        getResults() {

            const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-solid fa-download'});
            axios.get('addresses',).then(response => {
                toast.dismiss(id);
                this.items = response.data;
            }, response => {
                toast.dismiss(id);
            });

        },
        async _delete(item) {
            const toastId = toast.info('deleting ...', {icon: 'fa-solid fa-trash-arrow-up'});
            await axios.delete(`addresses/${item.id}`)
                .then(response => {
                    toast.dismiss(toastId);
                    // toast.success(response.data.message, {icon: 'fa-solid fa-trash-arrow-up'});
                    let i = this.items.data.map(v => v.id).indexOf(this.address_deleted.id);
                    this.items.data.splice(i, 1)

                });
        }
    }
}
</script>
